<template>
  <div class="chart-container">
    <chart :height="height1" :width="width1" :path="path1" :id="id1" :params="params1"/>
  </div>
</template>

<script>
import Chart from '@/components/Charts/Gauge'

export default {
  props: {
    path: {
      type: String
    }, id: {
      type: String
    }, height: {
      default:"100%",
      type: String
    }, width: {
      default:"100%",
      type: String
    }, params: {}
  },
  data() {
    return {
      path1: this.path,
      id1: this.id,
      chart_type1: this.chart_type,
      height1: this.height,
      width1: this.width,
      params1: this.params
    }
  },
  components: {Chart}
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
